import { makeAutoObservable } from "mobx";
import type { PostHog } from "posthog-js";

export const RECOMMENDATIONS_FLAG = "ordlyd-pa-snarvei-til-anbefalinger";

type PostHogStoreType = {
   posthog?: PostHog;
   init: (posthog: PostHog | undefined) => void;
   captureEvent: (event: string, additionalData?: Record<string, unknown>) => void;
};

export const posthogStore: PostHogStoreType = makeAutoObservable({
   init: (posthogInstance: PostHog | undefined) => {
      if (posthogInstance) {
         posthogStore.posthog = posthogInstance;
      }
   },
   captureEvent: (event: string, additionalData?: Record<string, unknown>) => {
      return posthogStore.posthog?.capture(event, additionalData);
   }
}) satisfies PostHogStoreType;

export default posthogStore;
